import scenes from './module/scenes'
import * as sources from './module/sources'
import stream from './module/stream'
import transitions from './module/transitions'
import durations from './module/durations'

export default {
	scenes,
	sources,
	stream,
	transitions,
	durations
}
